import { Component, OnInit } from '@angular/core';
import {AdministratorFeedbackRequestsSelectors} from "../../store/selectors";
import {UserProfileSelectors} from "../../../auth/store/selectors";
import {filter, switchMap, takeUntil, tap} from "rxjs/operators";
import {extractIri} from "../../../shared/utilities/objects.utility";
import {MatButtonToggleChange} from "@angular/material/button-toggle";
import {MatTabChangeEvent} from "@angular/material/tabs/tab-group";
import {Observable, Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {ApplicationState} from "../../../application-state/store";
import {AdministratorFeedbackRequestsActions} from "../../store";
import {AbstractApiService} from "../../../shared/services";
import {selectRecievedFeedbackRequests} from "../../store/selectors/feedback-requests.selectors";
import {FeedbackRequest} from "../../models";

@Component({
  selector: 'app-feedback-requests-received-widget',
  templateUrl: './feedback-requests-received-widget.component.html',
  styleUrls: ['./feedback-requests-received-widget.component.scss']
})
export class FeedbackRequestsReceivedWidgetComponent implements OnInit {
  isLoading$: Observable<boolean>;
  onDestroy$: Subject<void> = new Subject<void>();
  profile: string;
  selectedValue: Array<any> = [];
  selectedTab: string;
  feedbacks$: Observable<FeedbackRequest[]>;
  options = [
    { value: 'resolved', label: 'Beantwortet' },
    { value: 'answered', label: 'Erledigt' }
  ];

  constructor(private store$: Store<ApplicationState>, private apiService: AbstractApiService) {
  }
  ngOnInit(): void {
    this.isLoading$ = this.store$.select(AdministratorFeedbackRequestsSelectors.isLoading);
    this.store$
      .select(UserProfileSelectors.selectUserProfile)
      .pipe(
        takeUntil(this.onDestroy$),
        filter(profile => !!profile && !!profile['@id']),
        tap(profile => this.profile = extractIri(profile)),
        switchMap(() => this.store$.select(AdministratorFeedbackRequestsSelectors.selectRecievedFeedbackRequests))
      ).subscribe();
    this.feedbacks$ = this.store$.select(AdministratorFeedbackRequestsSelectors.selectRecievedFeedbackRequests);
  }

  onToggleChange(event: MatButtonToggleChange) {
    this.selectedValue = event.value;
  }

  onTabFocusChange(event: MatTabChangeEvent) {
    this.selectedTab = event.tab.textLabel;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  readonly AdministratorFeedbackRequestsActions = AdministratorFeedbackRequestsActions;
}
